import { ORGANISATION_FETCHED } from "utils/constants";

const dispatchOrganisation = (dispatch) => (data) => {
  return dispatch({
    type: ORGANISATION_FETCHED,
    data: { organisation: data.organisation || data }
  });
}

export const fetchOrganisation = (orgId) => (dispatch, getState) => {
  const { api } = getState().app;

  api.fetchOrganisation(orgId)
    .then(dispatchOrganisation(dispatch));
};

export const updateOrganisation = (attrs) => (dispatch, getState) => {
  const { api } = getState().app;

  return api.updateOrganisation(attrs)
    .then(dispatchOrganisation(dispatch));
};

export const createOrganisation = (attrs) => (dispatch, getState) => {
  const { api } = getState().app;

  return api.createOrganisation(attrs)
    .then(dispatchOrganisation(dispatch));
};

export const fetchOrganisations = () => (dispatch, getState) => {
  const { api } = getState().app;

  return api.fetchOrganisations()
    .then((data) => {
      data.organisations.forEach(dispatchOrganisation(dispatch));
    });
};



// WEBPACK FOOTER //
// ./src/actions/organisations.js